export default function (computed, item) {
  let description = item.description
  if (!description) return null

  description = description.replace(/{str}/g, computed?.abilities.value.str || 'STR')
  description = description.replace(/{dex}/g, computed?.abilities.value.dex || 'DEX')
  description = description.replace(/{con}/g, computed?.abilities.value.con || 'CON')
  description = description.replace(/{int}/g, computed?.abilities.value.int || 'INT')
  description = description.replace(/{wis}/g, computed?.abilities.value.wis || 'WIS')
  description = description.replace(/{cha}/g, computed?.abilities.value.cha || 'CHA')
  description = description.replace(/{prof}/g, computed?.difficulty.value.profBonus || 'proficiency')
  description = description.replace(/{lvl}/g, computed?.difficulty.value.level || 'difficulty level')
  description = description.replace(/{spellAb}/g, computed?.abilities.value[computed?.characterClass.spellAbility] || 'Sp.')

  return description
}
